import {DrawerNavigationCategoryTree_TreeItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/drawer_navigation.types';
import {CategoryTile} from '@aboutyou/ui-components';
import {ComponentProps} from 'react';

interface ThumbnailProps {
  categoryPreview: DrawerNavigationCategoryTree_TreeItem['categoryPreview'];
  isShowAll?: boolean;
}

export const normalizeThumbnail = ({
  categoryPreview,
  isShowAll,
}: ThumbnailProps): ComponentProps<typeof CategoryTile>['thumbnail'] => {
  switch (categoryPreview?.$case) {
    case 'productsCount': {
      return {
        count: {
          itemCount: categoryPreview?.productsCount.count,
          theme: isShowAll ? 'light' : 'dark',
        },
      };
    }
    case 'categoryImage': {
      return {
        image: {
          url: categoryPreview.categoryImage.src,
          padded: categoryPreview.categoryImage.isEnclosed,
          description: categoryPreview.categoryImage.description,
        },
      };
    }
    default:
      return undefined;
  }
};
